module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "stdapplinf-detail-pg20"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "700",
      "margin-bottom": "3px"
    }
  }, [_vm._v(_vm._s(_vm.labels['10']))]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.columns.pg20t1,
      "data": _vm.data,
      "selectRowBool": true,
      "tickEvent": _vm.rowEvent
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "700",
      "margin-bottom": "3px"
    }
  }, [_vm._v(_vm._s(_vm.labels['80']))]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.columns.pg20t2,
      "data": _vm.dataTappoinf
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-527ae224!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stdapplinf/stdapplinfDetailPg20.vue
// module id = 3756
// module chunks = 1